import { array } from 'fp-ts';
import { UseQueryResult } from '@tanstack/react-query';
import { CancellationPolicyWithProfiles, useRepositoryQuery } from '@mews-commander/data-access';
import { Optional } from '@mews/std';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useGetSelectedCancellationPolicies = (
    selectedCancellationFeeIds: Optional<string[]>
): UseQueryResult<Array<CancellationPolicyWithProfiles>> =>
    useRepositoryQuery(
        'cancellationPolicies',
        'getAll',
        {
            // @ts-expect-error, incorrect OpenAPI schema definition
            ids: null,
            enterpriseId: useCurrentEnterpriseId(),
        },
        {
            select: (result) =>
                array.isNonEmpty(result) && selectedCancellationFeeIds
                    ? result.filter(({ id }) => selectedCancellationFeeIds.includes(id))
                    : [],
        }
    );
